export enum SupportStatus {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  FIXED = 'FIXED',
  CANCELLED = 'CANCELLED',
}
